import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { ActingDetailQuerySteps } from '@area-restrita/api-client/model/actingDetailQuerySteps';

import { Badge } from '@/components/ui/badge';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';

import ActingResponseValue from './ActingResponseValue';
import {
  formatActingDateTime,
  getStepStatus,
} from './actingDetailsPresentation';

interface IProps {
  step: ActingDetailQuerySteps;
}

const ActingChecklistStep: React.FC<IProps> = ({ step }) => {
  const status = getStepStatus(step);
  const timestamp = step.finishedAt ?? step.startedAt;

  if (!step.responses.length) {
    return (
      <div className="flex items-center justify-between gap-4 rounded-lg border p-4">
        <div className="min-w-0">
          <p className="font-medium">{step.name}</p>
          <p className="text-sm text-muted-foreground">
            {timestamp ? formatActingDateTime(timestamp) : 'Não iniciada'}
          </p>
        </div>
        <Badge variant="secondary">{status}</Badge>
      </div>
    );
  }

  return (
    <Dialog>
      <DialogTrigger asChild>
        <button
          type="button"
          className="flex w-full items-center justify-between gap-4 rounded-lg border p-4 text-left transition-colors hover:bg-accent"
        >
          <div className="min-w-0">
            <p className="font-medium">{step.name}</p>
            <p className="text-sm text-muted-foreground">
              {timestamp ? formatActingDateTime(timestamp) : 'Não iniciada'}
            </p>
          </div>
          <div className="flex shrink-0 items-center gap-2">
            <Badge variant="secondary">{status}</Badge>
            <ChevronRightIcon className="size-4 text-muted-foreground" />
          </div>
        </button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-xl">
        <DialogHeader>
          <DialogTitle>{step.name}</DialogTitle>
          <DialogDescription>
            {status}
            {timestamp ? ` em ${formatActingDateTime(timestamp)}` : ''}
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          {step.responses.map((response) => (
            <ActingResponseValue key={response.id} response={response} />
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ActingChecklistStep;
